//#region src/core/i18n/text/airplay.ts
const prefix = "airplay.";
const startText = {
	key: `${prefix}start`,
	text: "Start AirPlay"
};
const stopText = {
	key: `${prefix}stop`,
	text: "Stop AirPlay"
};
//#endregion
export { startText, stopText };
